<template>
  <div class="min-vh-100 bg-light d-flex flex-column align-items-center justify-content-center p-3">
    <div class="card shadow-sm border-0 w-100" style="max-width: 900px;">
      <div class="card-body">
        <h5 class="fw-bold text-center mb-3">Transport Voucher</h5>

        <!-- FORM Section -->
        <div class="row g-2 small">
          <div class="col-6"><label>Vessel</label><input v-model="form.vessel" class="form-control form-control-sm" required/></div>
          <div class="col-6"><label>PIC</label><input v-model="form.pic" class="form-control form-control-sm" /></div>
          <div class="col-6"><label>Driver</label><input v-model="form.driver" class="form-control form-control-sm" required/></div>
          <div class="col-6"><label>Date</label><input v-model="form.date" type="text" class="form-control form-control-sm" required/></div>
          <div class="col-6"><label>Time</label><input v-model="form.time" class="form-control form-control-sm" required/></div>
          <div class="col-6"><label>Vehicle No</label><input v-model="form.vehicleNo" class="form-control form-control-sm" required/></div>
          <div class="col-6"><label>From</label><input v-model="form.from" class="form-control form-control-sm" required/></div>
          <div class="col-6"><label>To</label><input v-model="form.to" class="form-control form-control-sm" required/></div>
          <div class="col-6"><label>Crew Rank & Name</label><input v-model="form.crew" class="form-control form-control-sm" required/></div>
          <div class="col-6"><label>Pax</label><input v-model="form.pax" class="form-control form-control-sm" required/></div>
          <div class="col-6"><label>Flight</label><input v-model="form.flight" class="form-control form-control-sm" /></div>
          <div class="col-12"><label>Remarks Line 1</label><input v-model="form.remarks" class="form-control form-control-sm" /></div>
          <div class="col-12"><label>Remarks Line 2</label><input v-model="form.remarks2" class="form-control form-control-sm" /></div>
        </div>

        <hr class="my-3" />

        <!-- CHARGES as SWITCHES (all amounts fixed at 0 in admin edit mode) -->
        <h6 class="fw-bold">Charges (SGD)</h6>
        <div class="row g-2 small">
          <div class="col-6 col-md-4 d-flex align-items-center">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="swTrip" v-model="form.trip">
              <label class="form-check-label" for="swTrip">Trip</label>
            </div>
          </div>
          <div class="col-6 col-md-4 d-flex align-items-center">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="swERP" v-model="form.erp">
              <label class="form-check-label" for="swERP">ERP</label>
            </div>
          </div>
          <div class="col-6 col-md-4 d-flex align-items-center">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="swParking" v-model="form.parking">
              <label class="form-check-label" for="swParking">Parking</label>
            </div>
          </div>
          <div class="col-6 col-md-4 d-flex align-items-center">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="swMeeting" v-model="form.meeting">
              <label class="form-check-label" for="swMeeting">Meeting</label>
            </div>
          </div>
          <div class="col-6 col-md-4 d-flex align-items-center">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="swMidnight" v-model="form.midnight">
              <label class="form-check-label" for="swMidnight">Midnight</label>
            </div>
          </div>
          <div class="col-6 col-md-4 d-flex align-items-center">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="swOthers" v-model="form.others">
              <label class="form-check-label" for="swOthers">Others</label>
            </div>
          </div>
          <div class="col-6 col-md-4 d-flex align-items-center">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="swWaiting" v-model="form.waiting">
              <label class="form-check-label" for="swWaiting">Waiting</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="input-group">
              <span class="input-group-text fw-semibold bg-light">Waiting</span>
              <input
                v-model="form.waitingValue"
                type="text"
                step="0.01"
                class="form-control"
                placeholder="Enter Hr and Mins Eg 0hr 5min"
              />
            </div>
          </div>

          <!-- <div class="col-md-4">
            <label class="fw-bold">Total SGD</label>
            <input value="0.00" class="form-control form-control-sm" readonly />
          </div> -->
        </div>

        <!-- SIGNATURE -->
        <div class="mt-4">
          <label class="fw-semibold">Signature</label>
          <canvas
            ref="signaturePad"
            class="border rounded bg-white w-100"
            style="height: 130px;"
            @mousedown="startSign"
            @mousemove="drawSign"
            @mouseup="endSign"
            @mouseleave="endSign"
            @touchstart.prevent="startSign"
            @touchmove.prevent="drawSign"
            @touchend.prevent="endSign"
          ></canvas>
          <button class="btn btn-sm btn-outline-secondary mt-2" @click="clearSign">
            Clear Signature
          </button>
        </div>

        <div class="text-center mt-4">
          <button class="btn btn-primary px-4" @click="saveVoucher" :disabled="isUploading">
            <span v-if="!isUploading">Save Voucher</span>
            <span v-else class="spinner-border spinner-border-sm"></span>
          </button>
        </div>
        <!-- 🔥 Hidden Voucher Canvas -->
        <canvas
          ref="voucherCanvas"
          style="display: none;"
        ></canvas>
      </div>
    </div>
  </div>


</template>

<script>
import axios from 'axios'
import router from '@/router'
import { useToast } from 'vue-toastification'

export default {
  name: 'TransportVoucher',
  data() {
    return {
      scaleFactor: 0.9,
      jobId: '',
      isUploading: false,
      drawing: false,
      ctx: null,
      role:"",
      voucherId:"",
      token:"",
      voucherImg: require('@/assets/transportVoucher.jpg'),
      // Keep original numeric fields (all 0) for backend compatibility
      form: {
        voucherId:'',
        vessel: '',
        pic: '',
        driver: '',
        date: '',
        time: '',
        vehicleNo: '',
        from: '',
        to: '',
        crew: '',
        pax: '',
        flight: '',
        remarks: '',
        remarks2: '',
        tripValue: 0,
        erpValue: 0,
        parkingValue: 0,
        meetingValue: 0,
        midnightValue: 0,
        waitingValue: "",
        othersValue: 0,
        trip: true,
        erp: false,
        parking: false,
        meeting: false,
        midnight: false,
        waiting: false,
        others: false
      }
    }
  },
  setup() {
    const toast = useToast()
    return { toast }
  },
 async mounted() {
    this.form.voucherId = this.$route.params.id
    this.voucherId = this.$route.params.id
    this.token = this.$route.params.token

    if (!this.token) {
      this.toast.error('Missing access token')
      return
    }

    // ✅ Verify token first
    const ok = await this.verifyAccessToken(this.token)
    if (!ok) {
      this.toast.error('Invalid or expired token')
      return
    }

    // ✅ Setup signature pad
    const c = this.$refs.signaturePad
    const rect = c.getBoundingClientRect()
    c.width = rect.width * window.devicePixelRatio
    c.height = rect.height * window.devicePixelRatio
    const ctx = c.getContext('2d')
    ctx.scale(window.devicePixelRatio, window.devicePixelRatio)
    // ✅ preload background voucher image
    const img = new Image()
    img.src = this.voucherImg
    img.onload = () => {
      this.voucherImg = img.src
      this.drawVoucher()
    }

    // ✅ redraw when values change
    Object.keys(this.form).forEach(key => {
      this.$watch(`form.${key}`, this.drawVoucher)
    })
    // ✅ Fetch booking after verifying
    this.fetchVoucher()
  },

  methods: {
    async verifyAccessToken(token) {
      try {
        const res = await axios.get(`${this.$apiURL}/api/token/verify`, {
          params: { token }
        })
        if (res.data.ok) {
          this.role = res.data.role || 'driver'
          this.toast.success('Access verified')
          return true
        }
      } catch (err) {
        console.error('❌ verifyAccessToken error:', err)
      }
      return false
    },
    async fetchVoucher() {
      try {
        if (!this.voucherId) return

        const headers = await this.getAuthHeader()
        const res = await axios.get(`${this.$apiURL}/api/vouchers/${this.voucherId}`, { headers })

        if (res.data?.voucherData) {
          const v = res.data.voucherData

          // ✅ Fill your voucher form from backend data
          this.form = {
            vessel: v.vessel || '',
            pic: v.pic || '',
            driver: v.driver || '',
            date: v.date || '',
            time: v.time || '',
            vehicleNo: v.vehicleNo || '',
            from: v.from || '',
            to: v.to || '',
            crew: v.crew || '',
            pax: v.pax || '',
            flight: v.flight || '',
            remarks: v.remarks || '',
            remarks2: v.remarks2 || '',
            tripValue: v.tripValue || 0,
            erpValue: v.erpValue || 0,
            parkingValue: v.parkingValue || 0,
            meetingValue: v.meetingValue || 0,
            midnightValue: v.midnightValue || 0,
            waitingValue: v.waitingValue || 0,
            othersValue: v.othersValue || 0,
            trip: !!v.trip,
            erp: !!v.erp,
            parking: !!v.parking,
            meeting: !!v.meeting,
            midnight: !!v.midnight,
            waiting: !!v.waiting,
            others: !!v.others, 
          }

          this.signatureUrl = res.data.signatureUrl || ''

          // 🖊️ optional — draw the old signature if got
          if (this.signatureUrl) {
            const img = new Image()
            img.crossOrigin = 'anonymous'
            img.src = this.signatureUrl
            img.onload = () => {
              const c = this.$refs.signaturePad
              const ctx = c.getContext('2d')
              const rect = c.getBoundingClientRect()
              ctx.drawImage(img, 0, 0, rect.width, rect.height)
            }
          }

        } else {
          this.toast.error('Voucher not found')
        }
      } catch (err) {
        console.error('❌ fetchVoucher error:', err)
        this.toast.error('Error loading voucher data')
      }
    },

    async getAuthHeader() {
      if (!this.token) throw new Error('Missing token')
      return { Authorization: this.token }
    },
    // signature
    startSign(e) {
      const c = this.$refs.signaturePad
      this.ctx = c.getContext('2d')
      this.ctx.strokeStyle = 'black'
      this.ctx.lineWidth = 2

      const rect = c.getBoundingClientRect()
      const pos = e.touches ? e.touches[0] : e
      const x = pos.clientX - rect.left
      const y = pos.clientY - rect.top

      this.drawing = true
      this.ctx.beginPath()
      this.ctx.moveTo(x, y)
      // draw a tiny dot to ensure stroke starts immediately
      this.ctx.lineTo(x + 0.1, y + 0.1)
      this.ctx.stroke()
    },

    drawSign(e) {
      if (!this.drawing) return
      const c = this.$refs.signaturePad
      const rect = c.getBoundingClientRect()
      const pos = e.touches ? e.touches[0] : e
      const x = pos.clientX - rect.left
      const y = pos.clientY - rect.top
      this.ctx.lineTo(x, y)
      this.ctx.stroke()
    },

    endSign() {
      if (!this.drawing) return
      this.drawing = false
      this.ctx.closePath()
      this.drawVoucher()
    },
    drawVoucher() {
      return new Promise((resolve, reject) => {
        const canvas = this.$refs.voucherCanvas;
        if (!canvas) {
          console.error("Voucher canvas ref not found");
          return resolve();
        }

        const ctx = canvas.getContext('2d');
        const img = new Image();
        
        // Enable CORS for images hosted on external servers (S3, Cloudinary, etc.)
        img.crossOrigin = 'anonymous'; 
        img.src = this.voucherImg;

        img.onload = () => {
          canvas.width = img.width * this.scaleFactor
          canvas.height = img.height * this.scaleFactor
          ctx.scale(this.scaleFactor, this.scaleFactor)
          ctx.drawImage(img, 0, 0)
          // --- 1. Draw Voucher ID (Red) ---
          ctx.fillStyle = 'red';
          ctx.font = 'bold 22px Arial';
          ctx.fillText(`${this.voucherId || ''}`, 980, 70)

          // --- 2. Draw Text Fields (Black) ---
          ctx.fillStyle = 'black';
          ctx.font = '25px Arial';

          // Basic Info Row 1
          ctx.fillText(`${this.form.vessel || ''}`, 130, 170);
          ctx.fillText(`${this.form.pic || ''}`, 540, 170);
          ctx.fillText(`${this.form.driver || ''}`, 980, 170);

          // Basic Info Row 2
          ctx.fillText(`${this.form.date || ''}`, 130, 230);
          ctx.fillText(`${this.form.time || ''}`, 560, 230);
          ctx.fillText(`${this.form.vehicleNo || ''}`, 1010, 230);

          // Basic Info Row 3
          ctx.fillText(`${this.form.from || ''}`, 130, 290);
          ctx.fillText(`${this.form.to || ''}`, 540, 290);

          // Crew & Pax
          ctx.fillText(`${this.form.crew || ''}`, 270, 350);
          ctx.fillText(`${this.form.pax || ''}`, 780, 345);
          ctx.fillText(`${this.form.flight || ''}`, 1000, 345);

          // Remarks
          ctx.fillText(`${this.form.remarks || ''}`, 150, 405);
          ctx.fillText(`${this.form.remarks2 || ''}`, 150, 455);

          // --- 3. Draw Checkmarks (✔) ---
          ctx.font = 'bold 24px Arial';
          if (this.form.trip) ctx.fillText('✔', 290, 520);
          if (this.form.erp) ctx.fillText('✔', 290, 560);
          if (this.form.parking) ctx.fillText('✔', 290, 595);
          if (this.form.meeting) ctx.fillText('✔', 290, 635);
          if (this.form.midnight) ctx.fillText('✔', 290, 675);
          if (this.form.waiting) ctx.fillText('✔', 290, 710);
          if (this.form.others) ctx.fillText('✔', 290, 750);

          // --- 4. Draw Signature ---
          const signCanvas = this.$refs.signaturePad;
          if (signCanvas) {
            const sigImg = new Image();
            // Convert signature pad to data URL
            sigImg.src = signCanvas.toDataURL('image/png');
            
            sigImg.onload = () => {
              const sigX = 800;
              const sigY = 510;
              const sigWidth = 300;
              const sigHeight = 120;
              
              ctx.drawImage(sigImg, sigX, sigY, sigWidth, sigHeight);
              
              // Final Resolution: Everything is drawn
              resolve();
            };

            sigImg.onerror = (err) => {
              console.error("Signature image failed to load", err);
              resolve(); // Resolve anyway so the process doesn't hang
            };
          } else {
            // No signature pad found, resolve immediately
            resolve();
          }
        };

        img.onerror = (err) => {
          console.error("Background voucher image failed to load", err);
          reject(err);
        };
      });
    },

    clearSign() {
      const c = this.$refs.signaturePad
      const ctx = c.getContext('2d')
      ctx.clearRect(0, 0, c.width, c.height)
    },

    async saveVoucher() {


      this.isUploading = true
      try {
        const headers = await this.getAuthHeader()
        const formData = new FormData()

        // attach signature
        const signCanvas = this.$refs.signaturePad
        const blob = await new Promise(resolve => signCanvas.toBlob(resolve, 'image/png'))
        if (blob) formData.append('signature', blob, `Signature_${this.voucherId}.png`)
        // regenerate voucher canvas first
        await this.drawVoucher()

        const voucherCanvas = this.$refs.voucherCanvas
        const voucherBlob = await new Promise(resolve =>
          voucherCanvas.toBlob(resolve, 'image/png')
        )

        if (voucherBlob) {
          formData.append(
            'file',
            voucherBlob,
            `Voucher_${this.voucherId}.png`
          )
        }
        // // numeric placeholders
        // const numericKeys = [
        //   'tripValue', 'erpValue', 'parkingValue', 'meetingValue',
        //   'midnightValue', 'waitingValue', 'othersValue', 'totalTrips', 'totalSGD'
        // ]
        // numericKeys.forEach(k => { this.form[k] = 0 })

        // append text/number fields
        Object.entries(this.form).forEach(([k, v]) => {
          formData.append(k, v ?? '')
        })

        // ✅ append booleans (checkbox)
        const boolKeys = ['trip', 'erp', 'parking', 'meeting', 'midnight', 'waiting', 'others']
        boolKeys.forEach(k => {
          formData.append(k, this.form[k])
        })

        const res = await axios.put(
          `${this.$apiURL}/api/vouchers/${this.voucherId}/replace`,
          formData,
          { headers }
        )

        if (res.data.ok) {
          router.push('/success/' + res.data.jobId + "/" + this.token)
        } else {
          this.toast.error(res.data.error || 'Failed to save voucher.')
        }
      } catch (err) {
        console.error('❌ saveVoucher error:', err)
        this.toast.error('Error saving voucher.')
      } finally {
        this.isUploading = false
      }
    },
    async fetchBooking() {
      try {
        const headers = await this.getAuthHeader()
        const res = await axios.get(`${this.$apiURL}/api/bookings/${this.$route.params.jobId}`, { headers })
        if (!res.data?.booking) {
          this.toast.error('Booking not found')
          return
        }

        const b = res.data.booking
        this.booking = b

        // ✅ Fill your voucher form from booking data
        this.form.vessel = b.vesselName || b.vessel || ''
        this.form.pic = this.getClientName ? this.getClientName(b.clientId) : (b.pic || '')
        //this.form.driver = b.driverName || (Array.isArray(b.driverIDs) ? b.driverIDs.join(', ') : '')
        this.form.driver =""
        this.form.vehicleNo = b.vehicleNo || ''
        this.form.from = b.rawStartLocation || b.startLocation || ''
        // this.form.to = b.rawEndLocation || b.endLocation || ''
        this.form.crew = b.crew || ''
        this.form.pax = b.pax || ''
        this.form.flight = Array.isArray(b.flightNumbers)
          ? b.flightNumbers.map(f => f.flight || f.number).join(', ')
          : b.flight || ''
        this.form.remarks = b.remarks || ''
        this.form.remarks2 = b.remarks2 || ''

        // ✅ Convert startTime to Date + Time fields
        if (b.startTime) {
          const dt = new Date(b.startTime)
          const sg = new Date(dt.toLocaleString('en-US', { timeZone: 'Asia/Singapore' }))
          const yyyy = sg.getFullYear()
          const mm = String(sg.getMonth() + 1).padStart(2, '0')
          const dd = String(sg.getDate()).padStart(2, '0')
          const hh = String(sg.getHours()).padStart(2, '0')
          const min = String(sg.getMinutes()).padStart(2, '0')
          this.form.date =`${dd}/${mm}/${yyyy}`
          this.form.time = `${hh}:${min}`
        } else {
          this.form.date = ''
          this.form.time = ''
        }

      } catch (err) {
        console.error('❌ fetchBooking error:', err)
        this.toast?.error('Error loading booking details')
      }
    },

  }
}
</script>

<style scoped>
canvas { touch-action: none; }
@media (max-width: 768px) { canvas { height: auto !important; } }
</style>
